<div class="app-admin-wrap"
		 [dir]='layoutConf.dir'>
	<!-- ONLY REQUIRED FOR **TOP** NAVIGATION LAYOUT -->
	@if (layoutConf.navigationPos === 'top') {
	<app-header-top [tarifarioPanel]="tarifPanel"
									[titleMenu]="titleMenu" />
	}
	<!-- Main Container -->
	<mat-sidenav-container [dir]='layoutConf.dir'
												 class="app-admin-container app-side-nav-container mat-drawer-transition"
												 [class]="{
			'navigation-top': layoutConf.navigationPos === 'top',
			'sidebar-full': layoutConf.sidebarStyle === 'full',
			'sidebar-compact': layoutConf.sidebarStyle === 'compact' && layoutConf.navigationPos === 'side',
			'sidebar-compact-big': layoutConf.sidebarStyle === 'compact-big' && layoutConf.navigationPos === 'side',
			'layout-intransition': layoutConf.layoutInTransition,
			'sidebar-opened': layoutConf.sidebarStyle !== 'closed' && layoutConf.navigationPos === 'side',
			'sidebar-closed': layoutConf.sidebarStyle === 'closed',
			'fixed-topbar': layoutConf.topbarFixed && layoutConf.navigationPos === 'side'
		}">
		<!-- SIDEBAR -->
		<!-- ONLY REQUIRED FOR **SIDE** NAVIGATION LAYOUT -->
		@if (layoutConf.navigationPos === 'side') {
		<app-sidebar-side />
		}

		<!-- Top navigation layout (navigation for mobile screen) -->
		<!-- ONLY REQUIRED FOR **TOP** NAVIGATION MOBILE LAYOUT -->
		@if (layoutConf.navigationPos === 'top' && layoutConf.isMobile) {
		<app-sidebar-top />
		}

		<!-- App content -->
		<div class="main-content-wrap">
			<!-- Header for side navigation layout -->
			<!-- ONLY REQUIRED FOR **SIDE** NAVIGATION LAYOUT -->
			@if (layoutConf.navigationPos === 'side') {
			<app-header-side [tarifarioPanel]="tarifPanel" />
			}

			<div class="rightside-content-hold">
				<!-- View Loader -->
				@if (isModuleLoading) {
				<div class="view-loader">
					<div class="spinner">
						<div class="double-bounce1 mat-bg-accent"></div>
						<div class="double-bounce2 mat-bg-primary"></div>
					</div>
				</div>
				}
				<!-- Breadcrumb -->
				<app-breadcrumb />
				<!-- View outlet -->
				<router-outlet />
			</div>
		</div>
		<!-- View overlay for mobile navigation -->
		<div class="sidebar-backdrop"
				 [ngClass]="{'visible': layoutConf.sidebarStyle !== 'closed' && layoutConf.isMobile}"
				 (click)="closeSidebar()"></div>


		<mat-sidenav #tarifPanel
								 mode="over"
								 class=""
								 position="end">
			<div class="layout__navigation">
				<app-tarifarios [tarifarioPanel]="tarifPanel"
												(messageTitle)="titleMenu = $event" />
			</div>
		</mat-sidenav>
	</mat-sidenav-container>

</div>